import { render, staticRenderFns } from "./shareMod.vue?vue&type=template&id=03bd6910&scoped=true&"
import script from "./shareMod.vue?vue&type=script&lang=js&"
export * from "./shareMod.vue?vue&type=script&lang=js&"
import style0 from "./shareMod.vue?vue&type=style&index=0&id=03bd6910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd6910",
  null
  
)

export default component.exports